// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import LeadsUserTable from './leads-table';
// assets
//

// ----------------------------------------------------------------------

export default function LeadsAdmin() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <LeadsUserTable />
        </Container >
    );
}
